export enum PhysicalTreatmentEnum {
	DryNeedling = 'Dry Needling',
	PregnancyTherapy = 'Fysiotherapie bij zwangerschapsklachten',
	RunningAnalysis = 'Hardloopanalyse',
	MedicalTaping = 'Medical Taping',
	PrePostSurgery = 'Pre- en postoperatieve begeleiding',
	ShockwaveTherapy = 'Shockwave Therapie',
	Mobilising = 'Mobiliseren',
	SportMassage = 'Sportmassage',
	SportRehabilitation = 'Sportrevalidatie',
	Glad = 'GLA:D'
}
